import {Checkbox, Form} from 'antd';
import React, {FC} from 'react';

export interface ICheckboxSimpleProps {
    name: string;
    label?: string;
}
export const CheckboxSimple: FC<ICheckboxSimpleProps> = ({name, label}: ICheckboxSimpleProps) => (
    <Form.Item
        name={name}
        style={{marginBottom: 0}}
    >
        <Checkbox>{label}</Checkbox>
    </Form.Item>
);
